/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2022-07-07 10:26:48
 * @LastEditors: linxi
 * @LastEditTime: 2022-09-21 09:40:01
 */
import { createAsyncThunk } from '@reduxjs/toolkit'
import _ from 'lodash'
import { sendAsync } from '../../../app/applicationSlice'
import { RootThunkApi } from '../../../app/store'
import {
  messageUserList,
  NotificationCenterDeleteSubmit,
  NotificationCenterDeleteSubmitParams,
  NotificationCenterDetailParams,
  NotificationCenterDetailSubmit,
  NotificationCenterDetailSubmit2,
  NotificationCenterExpireSubmit,
  NotificationCenterExpireSubmitParams,
  NotificationCenterList,
  NotificationCenterParams,
  NotificationCenterPostponeSubmit,
  NotificationCenterPostponeSubmitParams,
  NotificationCenterSubmit,
  NotificationCenterSubmitParams,
} from '../../../services/notificationCenter'

// 列表
export const getNotificationCenterList = createAsyncThunk<
  void,
  NotificationCenterParams,
  RootThunkApi<void>
>('message/notificationCenterList', async (params, api) => {
  return sendAsync(NotificationCenterList(params), api)
})

//  创建人
export const getMessageUserList = createAsyncThunk<
  any,
  void,
  RootThunkApi<void>
>('message/creatPeopleList', async (params, api) => {
  return sendAsync(messageUserList(), api)
})
//新增编辑保存接口
export const getNotificationCenterSubmit = createAsyncThunk<
  void,
  NotificationCenterSubmitParams,
  RootThunkApi<void>
>('message/notificationCenterSubmit', async (params, api) => {
  return sendAsync(NotificationCenterSubmit(params), api)
})

//一键到期
export const getExpireSubmit = createAsyncThunk<
  void,
  NotificationCenterExpireSubmitParams,
  RootThunkApi<void>
>('message/notificationCenterSubmit', async (params, api) => {
  return sendAsync(NotificationCenterExpireSubmit(params), api)
})

//一键延期
export const getPostponeSubmit = createAsyncThunk<
  void,
  NotificationCenterPostponeSubmitParams,
  RootThunkApi<void>
>('message/notificationCenterSubmit', async (params, api) => {
  return sendAsync(NotificationCenterPostponeSubmit(params), api)
})

//删除
export const getDeleteSubmit = createAsyncThunk<
  void,
  NotificationCenterDeleteSubmitParams,
  RootThunkApi<void>
>('message/notificationCenterSubmit', async (params, api) => {
  return sendAsync(NotificationCenterDeleteSubmit(params), api)
})

//详情
export const getDetailData = createAsyncThunk<
  void,
  NotificationCenterDetailParams,
  RootThunkApi<void>
>('message/notificationCenterDetail', async (params, api) => {
  return sendAsync(NotificationCenterDetailSubmit(params), api)
})
//弹窗广告详情
export const getDetailData2 = createAsyncThunk<
  void,
  NotificationCenterDetailParams,
  RootThunkApi<void>
>('message/notificationCenterDetail2', async (params, api) => {
  return sendAsync(NotificationCenterDetailSubmit2(params), api)
})
